import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RankingComponent } from './ranking.component';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    DragulaModule
  ],
  declarations: [RankingComponent],
  providers: [DragulaService]
})
export class RankingModule { }



// WEBPACK FOOTER //
// ./src/app/ranking/ranking.module.ts